import PRESET from './world.json' assert { type: 'json' };

export const PRESET_ALT3 = JSON.stringify(PRESET);
